import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useLearningRoutesConditions } from '../../../../Learning/LearningRoutes'
import { LearningIcon } from '../../../../icons/LearningIcon'
import { TickmillProductType } from '../../../../model/TickmillProductType'
import { useAccountReadContext } from '../../../../utils/AccountContextContext'
import { isTickmillPartner } from '../../../../utils/companyName.utils'
import { MenuSection } from '../useMenuSections'

export const useLearningMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const { isLearningVisible } = useLearningRoutesConditions()

  return useMemo(
    () => ({
      id: 'learning',
      label: t('Tabs.Learning'),
      icon: LearningIcon,
      condition: isLearningVisible,
      children: [
        {
          id: 'getting-started',
          label: t('Learning.Getting Started'),
          path: '/dashboard/learning/getting-started',
          condition: !isTickmillPartner(account),
        },
        {
          id: 'trainings',
          label: t('Learning.Video Tutorials'),
          path: '/dashboard/learning/trainings',
          condition: !isTickmillPartner(account),
          products: [TickmillProductType.CFD],
        },
        {
          id: 'cqg-education-videos',
          label: t('Learning.CQG Education Videos'),
          path: '/dashboard/learning/cqg-education-videos',
          products: [TickmillProductType.ETD],
        },
        {
          id: 'tutorial-videos',
          label: t('Learning.Tutorial Videos'),
          path: '/dashboard/learning/tutorial-videos',
          products: [TickmillProductType.ETD],
        },
      ],
    }),
    [t, isLearningVisible, account]
  )
}
